import React from 'react';
import { FSHomePageLightBoxStore } from '../../_flux/stores/fs_home_page_light_box_store';
import { FSHomePageLightBox } from '../../_flux/components/fs_home_page_light_box/fs_home_page_light_box';
import { hideAction as hideFSHomePageLightBox } from '../../_flux/actions/fs_home_page_light_box_actions';
import { showAction as showUiLock } from '../../_flux/actions/ui_lock_actions';
import { showAction as showConfigurator } from '../../_flux/actions/catalog_configurator_actions';
import { handleView } from '../handle_view';

const stores = {
    state: FSHomePageLightBoxStore,
};

const render = ({ state }) => (
    <FSHomePageLightBox
        visible={state.visible}
        onClose={hideFSHomePageLightBox}
        onProceed={onProceed}
    />
);

export const init = (container, options) =>
    handleView(stores, render, options, container);

function onProceed() {
    window.sessionStorage.setItem( 'openConfigurator', '1' );
    hideFSHomePageLightBox();
    showConfigurator();
    //window.location = location.origin + TYROOLA.globals.baseUrl + '/tyre/';
}
